import { Link } from "react-router-dom";

const BlogListCard = (props) => {
  if (props?.data) {
    var { title, img, imgClass, content, category, cardLink } = props.data;
  }
  const temp = (
    <>
      {img && (
        <div className={imgClass ? imgClass : "card-img"}>
          <img src={img} alt="..." />
        </div>
      )}
      <div className="card-body">
        {category?.title && (
          <div className="card-category">{category?.title}</div>
        )}
        {title && <h5 className="card-title">{title}</h5>}
        {content && <p className="card-text">{content}</p>}
      </div>
    </>
  );
  if (!cardLink) {
    return <div className="blog-list-card card bg-grey my-2 px-2">{temp}</div>;
  }
  return (
    <a className="blog-list-card card bg-grey my-2 px-2" href={cardLink}>
      {temp}
    </a>
  );
};

export default BlogListCard;
